export const floatPattern = /^[-+]?[0-9]*\.?[0-9]+$/;
